import React from "react";

import "./styles.scss";

import { Container, Row, Col } from "reactstrap";
import Banner from "./components/Banner/Banner";
import JoinUs from "./components/JoinUs/JoinUs";
import OurCourses from "./components/OurCourses/OurCourses";
import Graduates from "./components/Graduates/Graduates";
import Speakers from "./components/Speakers/Speakers";
import Partners from "./components/Partners/Partners";
import InstagramFeed from "../../components/InstagramFeed/InstagramFeed";

const Home = () => {
    const graduates = [
        {
            name: 'Ignacio Monsalve',
            sport: 'Jugador Eldense F.C.',
            description: '"Lo que más me ha gustado del Máster es que es muy completo. Creo que tratan todos los temas con los que se va a encontrar un director deportivo"',
            image: 'ignacio-monsalve'
        },
        {
            name: 'Alejandra Gutierrez',
            sport: 'Jugadora de fútbol',
            description: '"Desde un principio supe que este curso me llenaría de muchísimo aprendizaje, los ponentes son gente con muchísima experiencia que ocupa puestos de gestión y de dirección importantes"',
            image: 'alejandra-gutierrez'
        },
        {
            name: 'María José Rojas',
            sport: 'Jugadora de la selección chilena de fútbol',
            description: '"El Máster es espectacular, creo que como jugadora muchas veces no se ve realmente el trabajo que requiere la gestión de un equipo, de formar o de llevar consigo un club entero así que para mí fue una gran experiencia"',
            image: 'maria-jose-rojas'
        },
        {
            name: 'Adriana Aguila',
            sport: null,
            description: '"El fútbol femenino debe profesionalizarse cada vez más, por eso valoro este master, he aprendido y conectado con gente muy importante de la industria"',
            image: 'adriana-aguila'
        },
        {
            name: 'Gerardo Torrado',
            sport: 'Ex jugador de la selección mexicana de fútbol',
            description: '"Haber jugado profesionalmente ayuda, pero no te da todas las herramientas para gestionar un club de fútbol. Este programa brinda una mirada y te nutre de distintas metodologías para emprender ese camino de manera segura"',
            image: 'gerardo-torrado'
        },
        {
            name: 'José Hanan',
            sport: 'Director Deportivo Necaxa',
            description: '"No se trata sólo de los contenidos y el conocimiento, este programa te brinda un network fundamental para avanzar e insertarse en la industria"',
            image: 'jose-hanan'
        },
        {
            name: 'Mario Yepes',
            sport: 'Ex jugador de la selección colombiana de fútbol',
            description: '"Latinoamérica necesita de este tipo de Máster en Dirección Deportiva. Es fundamental para la profesionalización del fútbol en la región"',
            image: 'mario-yepes'
        },
        {
            name: 'Abel Aguilar',
            sport: 'Entrenador de fútbol',
            description: '"El master es un programa muy completo no solo si quieres seguir con la gestión en un equipo profesional, tanto para la gestión de un equipo profesional como para la gestión de academias o categorías juveniles"',
            image: 'abel-aguilar'
        },
        {
            name: 'Leonardo Ponzio',
            sport: 'Ex jugador',
            description: '"El Máster me permitió encender aún mejor el concepto de gestión grupal y financiera dentro de un equipo profesional de fútbol"',
            image: 'leonardo-ponzio'
        },
        {
            name: 'Guido Pizarro',
            sport: 'Jugador de Tigres',
            description: '"Las ponencias la dan mucha gente importante que habla desde su experiencia y eso te da muchas herramientas para poder ver más allá de lo que pasa en el campo"',
            image: 'guido-pizarro'
        },
        {
            name: 'Mariano Andújar',
            sport: 'Ex jugador de fútbol. Mánager de Banfield',
            description: '"A medida que se acerca el final de tu carrera profesional, hay que prepararse para seguir vinculado a la gestión. Este programa te da todo lo que necesitas para seguir ese camino"',
            image: 'mariano-andujar'
        }
    ];

    const speakers = [
        {
            name: 'José Hernan',
            description: 'Director Deportivo Necaxa',
            image: 'jose-hernan'
        },
        {
            name: 'José María Buljubasich',
            description: 'Gerente Deportivo Cruzados/ Universidad Católica.',
            image: 'jose-maria-buljubasich'
        },
        {
            name: 'Nuria Martínez',
            description: 'Team Manager Selección Española de Fútbol.',
            image: 'nuria-martinez'
        },
        {
            name: 'Quentin Paquelier',
            description: 'Chief Marketing Officer América de México.',
            image: 'quentin-paquelier'
        },
        {
            name: 'Eduardo Coudet',
            description: 'Director Técnico',
            image: 'eduardo-coudet'
        },
        {
            name: 'Ivan Alonso',
            description: 'Director Deportivo Cruz Azul',
            image: 'ivan-alonso'
        }
    ];

    const partners = [
        {
            name: 'Kognia',
            image: 'kognia'
        },
        {
            name: 'Audax',
            image: 'audax'
        },
        {
            name: 'CAR',
            image: 'car'
        },
        {
            name: 'San Luis',
            image: 'san-luis'
        },
        {
            name: 'A.A Estudiantes',
            image: 'estudiantes'
        },
        {
            name: 'Academia Mascherano',
            image: 'academia-mascherano'
        },
        {
            name: 'Club Celaya',
            image: 'club-celaya'
        },
        {
            name: 'ULC',
            image: 'ulc'
        },
        {
            name: 'Real Pilar',
            image: 'real-pilar'
        },
        {
            name: 'CRM',
            image: 'crm'
        },
        {
            name: 'Intención Deportiva',
            image: 'intencion-deportiva'
        },
        {
            name: 'StatsBomb',
            image: 'statsbomb'
        },
    ];

    return (
        <>
            <link
                rel="stylesheet"
                type="text/css"
                charSet="UTF-8"
                href="https://cdnjs.cloudflare.com/ajax/libs/slick-carousel/1.6.0/slick.min.css"
            />
            <link
                rel="stylesheet"
                type="text/css"
                href="https://cdnjs.cloudflare.com/ajax/libs/slick-carousel/1.6.0/slick-theme.min.css"
            />
            <Banner />
            <JoinUs />
            <OurCourses />
            <Graduates graduates={graduates} />
            <Container tag="section" className="convenio-utn py-5">
                <Row>
                    <Col tag="article" xs="12" className="text-center pb-5">
                        <h2 className="title">Convenio con UTN</h2>
                    </Col>
                    <Col tag="article" md="6">
                        <p>En 2024 firmamos junto con la Universidad Tecnológica Nacional de Argentina un convenio para impulsar la formación y la innovación en la gestión deportiva.</p>
                        <p>Este acuerdo refuerza nuestro compromiso de promover la excelencia en la formación y gestión deportiva a través de la colaboración académica y profesional.</p>
                    </Col>
                    <Col tag="article" md="6">
                        <p>El convenio tiene como objetivo desarrollar actividades conjuntas como capacitaciones, cursos, eventos y programas de intercambio, además de fomentar el asesoramiento mutuo y la transferencia de conocimientos técnicos y científicos. </p>
                        <p>Este convenio subraya nuestra misión de formar líderes en la industria del fútbol y generar un impacto positivo en la sociedad a través de la educación y la innovación.</p>
                    </Col>
                    <Col tag="article" xs="12" className="bg-utn">
                        <img src="/images/logo-utn.png" alt="UTN" title="UTN" className="img-fluid" />
                    </Col>
                </Row>
            </Container>
            <Speakers speakers={speakers} />
            <Partners partners={partners} />
            <InstagramFeed />
        </>
    );
}

export default Home;
